import React, { useEffect, useRef, useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";

interface TextAreaState {
  label: string;
  value: any;
  onUpdate: any;
  rows?: number;
  labelAbove?: boolean;
  css?: string;
  hasFocus?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
}

const Textarea = ({
  label,
  value,
  onUpdate,
  rows = 3,
  labelAbove = false,
  css = "",
  hasFocus = false,
  disabled = false,
  readOnly = false,
}: TextAreaState) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (hasFocus) {
      inputRef?.current?.focus();
    }
  }, []);

  const labelRef = useRef<HTMLLabelElement>(null);
  const [paddingTop, setPaddingTop] = useState("1.5rem");

  useEffect(() => {
    if (labelRef.current) {
      const labelHeight = labelRef.current.offsetHeight;
      // Adjust padding dynamically
      const dynamicPadding = Math.max(labelHeight + 12, 24); // 8px buffer
      setPaddingTop(`${dynamicPadding}px`);
    }
  }, [label]);

  return (
    <FloatingLabel
      controlId="floatingInput"
      label={
        <span
          ref={labelAbove ? labelRef : undefined}
          className={readOnly ? "app-orange-text fw-bold" : "px-0 form-floating-label-textarea"}
        >
          {label}
        </span>
      }
      style={labelAbove ? { paddingTop } : {}}
      className={css}
    >
      <Form.Control
        as="textarea"
        type="textarea"
        data-testid="textarea"
        value={value ? value : readOnly ? "No Value" : ""}
        onChange={onUpdate}
        style={{ height: "auto", paddingTop: "1.75rem" }}
        disabled={disabled}
        readOnly={readOnly}
        rows={rows}
        className={value && readOnly ? "form-control-readonly" : readOnly ? "form-control-readonly fst-italic" : "form-control-enabled"}
        ref={inputRef}
      />
    </FloatingLabel>
  );
};

export default Textarea;
